var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class Peoples extends Component {
    constructor() {
        super('Peoples', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('.people').on('click', (event, people) => {
                if (people.attr('href') == '#')
                    event.preventDefault();
            }).on('mouseenter', (event, people) => {
                let src = people.data('src');
                if (src) {
                    let image = $.parseHTML('<img src="' + src + '" alt="">');
                    $('#people-image-container').empty().append(image);
                }
            }).on('mouseleave', (event, people) => {
                $('#people-image-container').empty();
            });
            $('.e-mail').each((emailElement) => {
                try {
                    const b64Data = atob(emailElement.attr('href').replace('#', ''));
                    if (b64Data != '') {
                        const jsonData = JSON.parse(b64Data);
                        const address = Peoples.shiftChr(jsonData[0]);
                        const domain = Peoples.shiftChr(jsonData[1]);
                        emailElement.attr('href', 'mailto:' + address + '@' + domain);
                    }
                }
                catch (e) {
                }
            });
            this.success();
        });
    }
    static shiftChr(text) {
        let textData = text.split('');
        for (let index = 0; index < textData.length; index++) {
            textData[index] = String.fromCharCode(text.charCodeAt(index) - 5);
        }
        return textData.join('');
    }
}
